<template>
  <component :is="iconComponent" />
</template>

<script>
/**
 * @fileoverview Custom Icons
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

const icons = {
  client: () => import("./icons/client"),
  templates: () => import("./icons/templates"),
  tools: () => import("./icons/tools"),
  users: () => import("./icons/users"),
};

export default {
  name: "CustomIcons",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconComponent() {
      return icons[this.name];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>